"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Breadstick = _interopRequireDefault(require("../components/Breadstick"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var breadstick = new _Breadstick.default();
/**
 * Breadstick plugin
 */

var _default = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    Vue.prototype.$breadstick = breadstick;
  }
};
exports.default = _default;